import styled, { css } from 'styled-components'
import ripple from '../../../../styles/animations/ripple'
import { down } from 'styled-breakpoints'

export const Container = styled.div<{ open: boolean }>`
  position: absolute;
  height: 80vh;
  border-radius: 30px 0px 0px 30px;
  background: ${({ theme }) => theme.colors.secondary};
  box-shadow: -6px 4px 32px 0px rgba(0, 0, 0, 0.25);
  width: 425px;
  flex-direction: column;
  backdrop-filter: blur(30px) saturate(2);
  -webkit-backdrop-filter: blur(30px) saturate(2);
  transition: 1s cubic-bezier(0.36, -0.01, 0, 0.77);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  ${({ open }) =>
    open
      ? css`
          right: -0px;
        `
      : css`
          right: -100%;
        `}
  ${down('md')} {
    width: 100%;
    height: 100%;
    border-radius: 0px;
  }
`

export const ContentData = styled.div`
  height: fit-content;
  overflow-y: auto;
`

export const SideBarStyles = {
  Header: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    padding-bottom: 10px;
    border-bottom: 2px solid #64646420;
  `,
  ActionsContent: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 10px;
    svg {
      ${ripple}
      cursor: pointer;
    }
  `,
  Divider: styled.div`
    border-bottom: 2px solid #64646420;
  `,
  Title: styled.div`
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.title};
  `,
  ButtonsClose: styled.div`
    display: flex;
    flex-direction: row;
    gap: 5px;
    img {
      ${ripple}
      cursor: pointer;
      width: 25px;
      height: 25px;
    }
  `,
  Name: styled.div`
    font-size: 16px;
    text-transform: capitalize;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.title};
  `,
  Desc: styled.div`
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.title};
  `,

  RowItem: styled.div`
    border-top: 1px solid #8f8f8f;
    width: 100%;
    flex-direction: row;
    display: flex;
    gap: 15px;
    justify-content: space-between;
    padding: 10px 0px;
  `,
  RowName: styled.div`
    font-size: 12px;

    color: ${({ theme }) => theme.colors.title};
    width: 80%;
  `,
}
